/*
 * File: ContactDetail.tsx
 * Project: a-a
 * File Created: Wednesday, 8th January 2025 11:05:50 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 22nd July 2025 11:58:54 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomButton from '../../CustomButton/CustomButton';
import { Box, Chip, Divider, Skeleton, Typography, useTheme } from '@mui/material';
import zeplinColor from '../../../../theme/Color';
import CustomCard from '../../CustomCard/CustomCard';
import styles from './ContactDetail.module.css';

const ContactDetail = ({ selected, loading }: { selected: any; loading: boolean }) => {
  const screenHeight = window.innerHeight;
  const theme = useTheme();
  const name = selected?.name?.split(' ');
  return (
    <CustomCard
      styles={{
        // borderRadius: '14px',

        height: '100%',
        // screenHeight > 1200
        //   ? '60vh'
        //   : screenHeight > 1100
        //   ? '56vh'
        //   : screenHeight > 1000
        //   ? '53vh'
        //   : screenHeight > 900
        //   ? '47vh'
        //   : screenHeight > 800
        //   ? '41vh'
        //   : screenHeight > 700
        //   ? '34vh'
        //   : screenHeight > 600
        //   ? '20vh'
        //   : '10vh', //screenHeight > 640 ? '44vh' : screenHeight > 500 ? '36vh' : '34vh', //'40vh',
        backgroundColor: zeplinColor.Neutral1,
        borderWidth: `1px 1px 1px 1px`,
        borderStyle: 'solid',
        borderColor: `${zeplinColor.Neutral5}`,
        borderRadius: '14px 14px 0px 0px',
        overflowY: 'scroll',
      }}
    >
      <Box
        sx={{
          padding: { xs: '20px', xl: '24px' },
          display: 'flex',
          // flexDirection: 'column',
          // display: 'flex',
          gap: '12px',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          backgroundColor: zeplinColor.Neutral1,
          top: 0,
          height: { xs: '84px', xl: '104px' },
        }}
      >
        {/* <img src='/assets/dona-kelce.svg' width={56} height={56} style={{ objectFit: 'cover' }} /> */}
        {loading ? (
          <Skeleton variant='rounded' width={68} height={68} />
        ) : (
          <Box
            sx={{
              borderRadius: '14px',
              // padding: '10px',
              width: { xs: '58px', xl: '68px' },
              height: { xs: '58px', xl: '68px' },
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',

              gap: '10px',
              backgroundColor:
                // (index + 1) % 3 === 1
                //   ? zeplinColor.Blue3
                //   : index % 3 === 2
                //   ? zeplinColor.Green1
                zeplinColor.Brand1,
            }}
          >
            <Typography
              variant='responsiveDisplay5'
              color={zeplinColor.Neutral1}
              sx={{ textAlign: 'center' }}
            >
              {name?.map((value: any, index: number) =>
                index === 0 || index === name.length - 1 ? value[0] : '',
              )}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '8px',
            flex: 1,
          }}
        >
          {loading ? (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                flex: 1,
                // Optionally adjust other styles here
              }}
            />
          ) : (
            <Typography variant='responsiveDisplay5' style={{ textAlign: 'left' }}>
              {selected?.name}
            </Typography>
          )}
        </Box>
        {/* <Link
          to={`https://aamanagementgroup--aampreprod.sandbox.my.salesforce.com/'lightning/r/Account/${selected?.AccountId}/related/AccountContactRelations/view`}
          style={{ color: zeplinColor.BasicBlack, textDecoration: 'none' }}
        >
          <CustomCard
            styles={{
              borderRadius: '50px',
              padding: '10px 10px 10px 16px',
              backgroundColor: zeplinColor.Neutral1,
              border: `1px solid ${zeplinColor.Neutral6}`,
              display: 'flex',
              gap: '8px',
              // flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
              cursor: 'pointer',
            }}
          >
            <Typography variant='body3'>Salesforce</Typography>
            <img src='/assets/link-2.svg' width={20} height={20} />
          </CustomCard>
        </Link> */}
      </Box>
      <Divider
        component='div'
        sx={{
          borderColor: zeplinColor.Neutral5,
          position: 'sticky',
          top: { xs: '84px', xl: '104px' },
        }}
      />
      <Box sx={{ padding: { xs: '20px', xl: '24px' } }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '20px', xl: '24px' } }}>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img
                src='/assets/account-name.svg'
                className={styles.icon}
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Account name
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 1,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {/* Travis Kelce */}
                  {selected?.name}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img src='/assets/mobile.svg' className={styles.icon} style={{ objectFit: 'fill' }} />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Mobile
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 3,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selected?.phone ?? 'NA'}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img src='/assets/email.svg' className={styles.icon} style={{ objectFit: 'fill' }} />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Email
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 3,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selected?.email ?? 'NA'}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img
                src='/assets/relationship.svg'
                className={styles.icon}
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Relationship
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 3,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box sx={{ flex: 3 }}>
                  <Chip
                    label={
                      <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                        {selected?.roles ? selected?.roles : 'NA'}
                      </Typography>
                    }
                    sx={{
                      backgroundColor: zeplinColor.BasicBlack,
                      padding: '5px 12px 5px 12px',
                      borderRadius: '50px',
                      // width: '100%',
                      height: '24px',
                      '&.MuiChip-root': {
                        // flex: 1,
                      },
                    }}
                    // label={
                    //   <Typography
                    //     variant='label1'
                    //     color={zeplinColor.Neutral1}
                    //     sx={{
                    //       textAlign: 'center',
                    //       display: 'flex',
                    //       justifyContent: 'center',
                    //       alignItems: 'center',
                    //     }}
                    //   >
                    //     {selected?.roles}
                    //   </Typography>
                    // }
                  />
                </Box>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img
                src='/assets/birthdate.svg'
                className={styles.icon}
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Birthdate
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 3,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Typography variant='responsiveBody2' sx={{ flex: 3 }}>
                  {selected?.birthDate ?? 'NA'}
                </Typography>
              )}
            </Box>
          </Box>
          <Box sx={{ display: 'flex', gap: '48px' }}>
            <Box sx={{ display: 'flex', gap: '8px', flex: 1 }}>
              <img
                src='/assets/contact-owner.svg'
                className={styles.icon}
                style={{ objectFit: 'fill' }}
              />
              <Typography variant='responsiveBody2' color={zeplinColor.Neutral8} sx={{ flex: 1 }}>
                Contact Owner
              </Typography>

              {loading ? (
                <Skeleton
                  variant='text'
                  sx={{
                    fontSize: theme.typography.body2,
                    flex: 3,
                    // Optionally adjust other styles here
                  }}
                />
              ) : (
                <Box sx={{ display: 'flex', gap: '4px', flex: 3, alignItems: 'center' }}>
                  <Box
                    sx={{
                      borderRadius: '100px',
                      padding: '10px',
                      width: '26px',
                      height: '26px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: zeplinColor.Blue3,
                    }}
                  >
                    <Typography variant='responsiveLabel1' color={zeplinColor.Neutral1}>
                      {selected?.ownerName
                        ?.split(' ')
                        ?.map((value: any, index: number) =>
                          selected?.ownerName &&
                          (index === 0 || index === selected?.ownerName?.split(' ').length - 1)
                            ? value[0]
                            : '',
                        )}
                    </Typography>
                  </Box>
                  <Typography variant='responsiveBody2'>{selected?.ownerName ?? 'NA'}</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </CustomCard>
  );
};

export default ContactDetail;
